import log from 'salvo-lite/log'
import scrollToElement from 'scroll-to-element'

class Faq {
    constructor (components) {
        this._name = this.constructor.name
        this._components = components
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        const searchSubmit = document.querySelector('[data-submit]')
        const searchbar = document.querySelector('[data-faq-search]')
        searchSubmit.addEventListener('click', e => {
            this._search(searchbar)
        })
        searchbar.addEventListener('keyup', e => {
            if (e.keyCode === 13) {
                this._search(searchbar)
            }
        })
    }

    _search (searchbar) {
        const faqs = document.querySelectorAll('[data-faq]')
        const categorySelector = '[data-faq-category]'
        const searchableElemSelector = '[data-faq-searchable]'
        let allHidden = true
        const searchTerm = searchbar.value.toLowerCase().split(' ')
        allHidden = true
        let matched = []
        let catsMatched = []
        faqs.forEach(faq => {
            const faqCategory = faq.closest(categorySelector)
            let hideFAQ = true
            faq.querySelectorAll(searchableElemSelector).forEach(elem => {
                const isEvery = searchTerm.every(term => elem.innerHTML.toLowerCase().includes(term))
                if (isEvery) {
                    hideFAQ = false
                }
            })
            if (searchTerm === '') hideFAQ = false
            if (hideFAQ) {
                faq.classList.add('visually-hidden')
                const siblingFAQs = faqCategory.querySelectorAll('[data-faq]')
                let hideCategory = true
                siblingFAQs.forEach(siblingFAQ => { if (!siblingFAQ.classList.contains('visually-hidden')) hideCategory = false })
                hideCategory && faqCategory.classList.add('visually-hidden')
            } else {
                faq.classList.remove('visually-hidden')
                faqCategory.classList.remove('visually-hidden')
                allHidden = false
                matched.push(faq)
                catsMatched.push(faqCategory)
            }
        })
        if (matched.length === 1) {
            const open = matched[0].classList.contains('accordion-open')
            if (!open) {
                console.log(open)
                matched[0].querySelector('button').click()
            }
        } else {
            faqs.forEach(faq => {
                const open = faq.classList.contains('accordion-open')
                if (open) {
                    console.log(open)
                    faq.querySelector('button').click()
                }
            })
        }
        if (matched.length > 0) {
            scrollToElement(catsMatched[0], {
                offset: -80,
                duration: 750
            })
        }
        if (allHidden) {
            document.querySelector('.faq__no-results').classList.remove('visually-hidden')
        } else {
            document.querySelector('.faq__no-results').classList.add('visually-hidden')
        }
    }
}

export default Faq



// WEBPACK FOOTER //
// ./src/resources/scripts/pages/Faq.js